import { Component, OnInit, NgZone } from '@angular/core';
import { RegisterService } from './register.service';
import { Router } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { ToastController } from '@ionic/angular';
import { Toast } from '../globals';

// import { Camera, CameraOptions } from '@awesome-cordova-plugins/camera/ngx';
// import { Camera } from '@awesome-cordova-plugins/camera';

declare var $: any;

@Component({
  selector: 'app-register',
  templateUrl: './register.page.html',
  styleUrls: ['./register.page.scss'],
})
export class RegisterPage implements OnInit {
  ListAllCity: any;
  model: any = {};
  //private camera: Camera
  constructor(private register_serv: RegisterService, private router: Router, private alertController: AlertController, public zone: NgZone, private toastController: ToastController) {
    this.ShowCity();

  }

  ngOnInit() {
  }

  async presentToast(color, msg) {
    const toast = await this.toastController.create({
      message: msg,
      duration: 1500,
      color: color,
      position: 'top'
    });

    await toast.present();
  }


  ShowCity() {

    this.register_serv.ShowCity().subscribe(
      res => {
        this.zone.run(() => {
          this.ListAllCity = res;
          console.log("ListAllCity", this.ListAllCity);

        });

      }, err => {
        console.log(err);
      });
  }

  Save() {

    if (this.model.FirstName == undefined || this.model.LastName == undefined || this.model.EmailAddress == undefined || this.model.Password == undefined || this.model.Phone == undefined) {
      this.presentToast('warning', 'Please enter Name,LastName,Email,Password,Phone');
      return;
    }

    if (this.model.Sex == 'true') {
      this.model.Sex = true;
    } else {
      this.model.Sex = false;
    }
    // this.model.BrithDate=moment(this.model.BrithDate).format('YYYY-MM-DD');

    if (this.model.FK_CityID != undefined) {
      this.model.FK_CityID = Number(this.model.FK_CityID);
    } else {
      this.model.FK_CityID = 0;
    }

    console.log(this.model);

    this.register_serv.Register(this.model).subscribe(
      res => {

        console.log("res", res)

        if (res == true) {

          this.presentToast('success', 'Save Successfully');
          this.model = {};
          this.router.navigate(["/login"]);

        } else if (res == false) {
          this.presentToast('warning', 'Email was Exist!');
        } else {
          this.presentToast('danger', 'Error Saving Data');
        }

      }, err => {
        console.log(err);
      });

  }


  // camerad() {

  //   const options: CameraOptions = {
  //     quality: 100,
  //     destinationType: this.camera.DestinationType.FILE_URI,
  //     encodingType: this.camera.EncodingType.JPEG,
  //     mediaType: this.camera.MediaType.PICTURE
  //   }

  //   this.camera.getPicture(options).then((imageData) => {
  //     // imageData is either a base64 encoded string or a file URI
  //     // If it's base64 (DATA_URL):
  //     let base64Image = 'data:image/jpeg;base64,' + imageData;
  //   }, (err) => {
  //     // Handle error
  //   });

  // }

  // Camera() {
  //   document.addEventListener('deviceready', () => {
  //     Camera.getPicture()
  //       .then((data) => console.log('Took a picture!', data))
  //       .catch((e) => console.log('Error occurred while taking a picture', e));
  //   });

  // }

}
